import { Group, Text } from "@mantine/core";
import { EntityClientAction, MultiDataMapForm } from "@mcurros2/microm";
import { IconAlertCircle, IconBuildingStore, IconUserPin } from "@tabler/icons-react";
import { Dashboard } from "./Dashboard";

export const ACTVerHistorialCheckinVerUbicacion: EntityClientAction = {
    name: 'ACTVerHistorialCheckinVerUbicacion',
    label: 'Ver Ubicación Checkin',
    title: <Text fw={700}>Ver Ubicación Checkin</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'dash_brwPersonalHistorialCheckin'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const parent = entity as Dashboard;
        const dashboard = new Dashboard(entity.API.client);
        dashboard.parentKeys = parent.parentKeys;
        dashboard.def.columns.c_datos_checkin_id.value = selectedKeys![0].c_datos_checkin_id as unknown as string || '';
 
        await modal.open({
            modalProps: {
                title: <Group><IconAlertCircle size="1.5rem" stroke="1.5" /> <Text fw="700">Historial de Chekin</Text></Group>,
                size: "fullscreen"
            },
            focusOnClosed: element,
            content: <MultiDataMapForm
                autoFocus
                formMode="edit"
                key={`mapa-ver-ubicacion-checkin${entity.def.name}`}
                title="Historial de Checkin"
                dataMapView1={{
                    entity: dashboard,
                    viewName: dashboard.def.views.dash_brwPersonalHistorialCheckinVerUbicacion.name,
                    parentKeys: dashboard.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 6, longitudRecordIndex: 7,
                    tabLabel: "Ubicación Checkin",
                    tabIcon: IconUserPin,
                    enableView: false,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%"
                }}

                dataMapView2={{
                    entity: dashboard,
                    viewName: dashboard.def.views.dash_brwPersonalHistorialCheckinVerUbicacionTienda.name,
                    parentKeys: dashboard.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 11, longitudRecordIndex: 12,
                    tabLabel: "Ubicación Tienda",
                    tabIcon: IconBuildingStore,
                    enableView: false,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%"
                }}

                mapHeight="50vh"
            />
        });

        return false;
    }
}